import { render, staticRenderFns } from "./OptimaSettingsContractorView.vue?vue&type=template&id=77d68e42&scoped=true&"
import script from "./OptimaSettingsContractorView.vue?vue&type=script&lang=js&"
export * from "./OptimaSettingsContractorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d68e42",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77d68e42')) {
      api.createRecord('77d68e42', component.options)
    } else {
      api.reload('77d68e42', component.options)
    }
    module.hot.accept("./OptimaSettingsContractorView.vue?vue&type=template&id=77d68e42&scoped=true&", function () {
      api.rerender('77d68e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/optima/OptimaSettingsContractorView.vue"
export default component.exports